import { render, staticRenderFns } from "./policy-info-content.vue?vue&type=template&id=680977ab&scoped=true&"
import script from "./policy-info-content.vue?vue&type=script&lang=ts&"
export * from "./policy-info-content.vue?vue&type=script&lang=ts&"
import style0 from "./policy-info-content.vue?vue&type=style&index=0&id=680977ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680977ab",
  null
  
)

export default component.exports